/* COOLANDBAG — « Complète le fit » : constructeur d'outfit, ajout groupé au panier */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt;
  try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); } catch (e) { fmt = null; }
  function money(c) { var v = c / 100; return fmt ? fmt.format(v) : v.toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  var ARROW_L = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var PLUS = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; });
    }).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'cab-fit', data: { itemCount: cart.item_count, source: 'cab-fit' } } }));
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) { setTimeout(function () { try { drawer.open(); } catch (e) {} }, 900); }
      return cart;
    });
  }

  function init(root) {
    if (root.dataset.cabReady) return;
    var data;
    try { data = JSON.parse(root.querySelector('[data-cab-fit-data]').textContent); } catch (e) { return; }
    root.dataset.cabReady = '1';
    var slots = (data.slots || []).filter(function (s) { return s.items && s.items.length; });
    if (!slots.length) { root.hidden = true; return; }
    var tilesBox = root.querySelector('[data-cab-fit-tiles]');
    var tabsBox = root.querySelector('[data-cab-fit-tabs]');
    var railBox = root.querySelector('[data-cab-fit-rail]');
    var linesBox = root.querySelector('[data-cab-fit-lines]');
    var totalEl = root.querySelector('[data-cab-fit-total]');
    var countEl = root.querySelector('[data-cab-fit-count]');
    var msgEl = root.querySelector('[data-cab-fit-msg]');
    var cta = root.querySelector('[data-cab-fit-cta]');
    var done = root.querySelector('[data-cab-fit-done]');
    var doneN = root.querySelector('[data-cab-fit-done-n]');
    var st = { idx: [], on: [], size: [], active: 0, busy: false };
    slots.forEach(function (s, i) {
      st.idx[i] = 0; st.on[i] = true; st.size[i] = null;
      if (s.here && data.hereSize) st.size[i] = data.hereSize;
    });
    st.active = slots.findIndex(function (s) { return !s.here; });
    if (st.active < 0) st.active = 0;

    function item(i) { return slots[i].items[st.idx[i]]; }
    function pool(it) {
      var vs = it.vs || [];
      if (it.ci < 0 || it.c == null) return vs;
      var p = vs.filter(function (v) { return v[2][it.ci] === it.c; });
      return p.length ? p : vs;
    }
    function sizes(it) {
      if (it.si < 0) return [];
      var seen = {}, out = [];
      pool(it).forEach(function (v) {
        var s = v[2][it.si];
        if (!seen[s]) { seen[s] = { v: s, ok: false }; out.push(seen[s]); }
        if (v[1]) seen[s].ok = true;
      });
      return out;
    }
    function variantFor(i) {
      var it = item(i), p = pool(it);
      if (it.si < 0) return p.find(function (v) { return v[1]; }) || null;
      if (!st.size[i]) return null;
      return p.find(function (v) { return v[2][it.si] === st.size[i] && v[1]; }) || null;
    }
    function priceOf(i) { var v = variantFor(i) || pool(item(i)).find(function (x) { return x[1]; }) || item(i).vs[0]; return v ? v[3] : 0; }
    function colorOf(it) { return it.c || it.v || ''; }

    /* ---------- Tuiles ---------- */
    function tileHTML(i) {
      var s = slots[i], it = item(i);
      if (!st.on[i]) return '<button type="button" class="cab-fit__empty" data-act="on" data-i="' + i + '">' + PLUS + '<span>Ajouter ' + esc(s.article) + '</span></button>';
      return '<div class="cab-fit__media">' + (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" loading="lazy">' : '') + '</div>' +
        '<span class="cab-fit__chips"><b>' + esc(s.label) + '</b><i>' + (st.idx[i] + 1) + '/' + s.items.length + '</i></span>' +
        (it.here ? '<span class="cab-fit__here">Sur cette page</span>' : '') +
        (s.items.length > 1 ? '<button type="button" class="cab-fit__more" data-act="browse" data-i="' + i + '">Voir les ' + s.items.length + ' ' + esc(s.plural) + ' →</button>' : '') +
        '<a class="cab-fit__plate" href="' + esc(it.u) + '"><b>' + esc(it.t) + '</b><span>' + money(priceOf(i)) + '</span></a>' +
        (s.items.length > 1 ? '<button type="button" class="cab-fit__arrow cab-fit__arrow--p" data-act="prev" data-i="' + i + '" aria-label="' + esc(s.label) + ' précédent">' + ARROW_L + '</button>' +
        '<button type="button" class="cab-fit__arrow cab-fit__arrow--n" data-act="next" data-i="' + i + '" aria-label="' + esc(s.label) + ' suivant">' + ARROW_R + '</button>' : '');
    }
    var tiles = slots.map(function (s, i) {
      var t = document.createElement('div');
      t.className = 'cab-fit__tile' + (s.contain ? ' cab-fit__tile--contain' : '');
      tilesBox.appendChild(t);
      return t;
    });
    function renderTile(i) { tiles[i].innerHTML = tileHTML(i); }

    function swap(i, d, to) {
      var n = slots[i].items.length;
      if (n < 2 && to === undefined) return;
      var next = to !== undefined ? to : (st.idx[i] + d + n) % n;
      if (next === st.idx[i]) return;
      hideDone();
      var parts = tiles[i].querySelectorAll('.cab-fit__media, .cab-fit__plate');
      if (reduce || !parts.length) { st.idx[i] = next; st.size[i] = null; renderAll(); return; }
      parts.forEach(function (p) { p.style.transform = 'translateX(' + (-d * 46) + 'px)'; p.style.opacity = '0'; });
      setTimeout(function () {
        st.idx[i] = next; st.size[i] = null;
        renderTile(i); renderLines(); renderRail();
        var np = tiles[i].querySelectorAll('.cab-fit__media, .cab-fit__plate');
        np.forEach(function (p) { p.style.transition = 'none'; p.style.transform = 'translateX(' + (d * 46) + 'px)'; p.style.opacity = '0'; });
        void tiles[i].offsetWidth;
        np.forEach(function (p) { p.style.transition = ''; p.style.transform = ''; p.style.opacity = ''; });
      }, 180);
    }
    tilesBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b) return;
      var i = Number(b.getAttribute('data-i')), act = b.getAttribute('data-act');
      if (act === 'prev') swap(i, -1);
      if (act === 'next') swap(i, 1);
      if (act === 'on') { st.on[i] = true; hideDone(); renderAll(); }
      if (act === 'browse') { st.active = i; renderTabs(); renderRail(); railBox.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); }
    });

    /* ---------- Rayon ---------- */
    function renderTabs() {
      tabsBox.innerHTML = '<span>Tout le rayon</span>' + slots.map(function (s, i) {
        return '<button type="button" class="cab-fit__tab" data-i="' + i + '" aria-pressed="' + (st.active === i) + '">' + esc(s.label) + ' <i>' + s.items.length + '</i></button>';
      }).join('');
    }
    function renderRail() {
      var s = slots[st.active];
      railBox.setAttribute('aria-label', 'Choisir ' + s.article);
      railBox.innerHTML = s.items.map(function (it, k) {
        var cur = st.on[st.active] && st.idx[st.active] === k;
        var p = (pool(it).find(function (v) { return v[1]; }) || it.vs[0] || [0, 0, 0, 0])[3];
        return '<button type="button" class="cab-fit__ri' + (s.contain ? ' cab-fit__ri--contain' : '') + '" data-k="' + k + '" aria-pressed="' + cur + '">' +
          (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '<b>' + esc(it.t) + '</b><span>' + money(p) + '</span></button>';
      }).join('');
    }
    tabsBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]'); if (!b) return;
      st.active = Number(b.getAttribute('data-i')); renderTabs(); renderRail();
    });
    railBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-k]'); if (!b) return;
      var k = Number(b.getAttribute('data-k')), i = st.active;
      if (!st.on[i]) { st.on[i] = true; st.idx[i] = k; st.size[i] = null; renderAll(); return; }
      if (k !== st.idx[i]) swap(i, k > st.idx[i] ? 1 : -1, k);
    });

    /* ---------- Ticket ---------- */
    function renderLines() {
      linesBox.innerHTML = slots.map(function (s, i) {
        var it = item(i), on = st.on[i];
        var id = 'cab-fit-' + root.id + '-' + i;
        var sz = on ? sizes(it) : [];
        return '<div class="cab-fit__line' + (on ? '' : ' is-off') + '" data-line="' + i + '">' +
          '<div class="cab-fit__lt"><input type="checkbox" id="' + id + '" data-i="' + i + '"' + (on ? ' checked' : '') + '>' +
          '<label for="' + id + '"><small>' + esc(s.label) + '</small><span>' + esc(it.t) + (colorOf(it) ? ' · ' + esc(colorOf(it)) : '') + '</span></label>' +
          '<b>' + money(priceOf(i)) + '</b></div>' +
          (sz.length > 1 ? '<div class="cab-fit__sz" role="group" aria-label="' + esc((it.sn || 'Taille') + ' — ' + s.label) + '">' + sz.map(function (o) {
            return '<button type="button" data-i="' + i + '" data-s="' + esc(o.v) + '" aria-pressed="' + (st.size[i] === o.v) + '"' + (o.ok ? '' : ' disabled') + '>' + esc(o.v) + '</button>';
          }).join('') + '</div>' : '') + '</div>';
      }).join('');
      var n = 0, tot = 0;
      slots.forEach(function (s, i) { if (st.on[i]) { n++; tot += priceOf(i); } });
      totalEl.textContent = money(tot);
      if (countEl) countEl.textContent = n + (n > 1 ? ' pièces' : ' pièce');
      if (!st.busy) cta.textContent = cta.getAttribute('data-label') + ' · ' + n + (n > 1 ? ' articles' : ' article');
    }
    linesBox.addEventListener('change', function (e) {
      var c = e.target.closest('input[type="checkbox"]'); if (!c) return;
      var i = Number(c.getAttribute('data-i'));
      st.on[i] = c.checked; say(''); hideDone(); renderAll();
    });
    linesBox.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-s]'); if (!b || b.disabled) return;
      var i = Number(b.getAttribute('data-i'));
      st.size[i] = b.getAttribute('data-s'); say(''); hideDone();
      renderLines(); renderTile(i);
    });

    function say(t) { msgEl.textContent = t || ''; }
    function hideDone() { if (done) done.hidden = true; }

    function addAll() {
      if (st.busy) return;
      var chosen = [], missing = [];
      slots.forEach(function (s, i) {
        if (!st.on[i]) return;
        var v = variantFor(i);
        if (!v) missing.push(i); else chosen.push({ i: i, id: v[0] });
      });
      linesBox.querySelectorAll('.cab-fit__line').forEach(function (l) { l.classList.toggle('is-warn', missing.indexOf(Number(l.getAttribute('data-line'))) > -1); });
      if (!chosen.length && !missing.length) { say('Ajoute au moins une pièce au fit.'); return; }
      if (missing.length) {
        say('Choisis la taille : ' + missing.map(function (i) { return slots[i].label.toLowerCase(); }).join(', ') + '.');
        var first = linesBox.querySelector('.cab-fit__line.is-warn button:not([disabled])');
        if (first) first.focus({ preventScroll: false });
        return;
      }
      st.busy = true; say(''); cta.disabled = true; cta.textContent = 'Ça part dans ton sac…';
      var k = 0;
      if (!reduce) chosen.forEach(function (c) { var t = tiles[c.i]; t.style.transitionDelay = (k++ * 140) + 'ms'; t.classList.add('is-flying'); });
      var anim = new Promise(function (res) { setTimeout(res, reduce ? 0 : 1300); });
      Promise.all([addItems(chosen.map(function (c) { return { id: c.id, quantity: 1 }; })), anim]).then(function () {
        if (doneN) doneN.textContent = chosen.length;
        if (done) done.hidden = false;
      }).catch(function (err) {
        say(err && err.message ? err.message : 'Erreur, réessaie.');
      }).then(function () {
        tiles.forEach(function (t) { t.classList.add('is-back'); t.style.transitionDelay = ''; t.classList.remove('is-flying'); });
        setTimeout(function () { tiles.forEach(function (t) { t.classList.remove('is-back'); }); }, 450);
        st.busy = false; cta.disabled = false; renderLines();
      });
    }
    cta.addEventListener('click', addAll);

    var shuffle = root.querySelector('[data-cab-fit-shuffle]');
    if (shuffle) shuffle.addEventListener('click', function () {
      slots.forEach(function (s, i) {
        if (!st.on[i] || s.items.length < 2) return;
        var to = Math.floor(Math.random() * s.items.length);
        if (to === st.idx[i]) to = (to + 1) % s.items.length;
        setTimeout(function () { swap(i, 1, to); }, i * 140);
      });
    });

    function renderAll() { tiles.forEach(function (t, i) { renderTile(i); }); renderTabs(); renderRail(); renderLines(); }
    renderAll();
  }

  function scan(r) { (r || document).querySelectorAll('[data-cab-fit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
